<template>
  <b-modal
    v-model="showProfilePictureModal"
    centered
    ok-variant="primary"
    :ok-disabled="!changed || savingProfilePicture"
    cancel-variant="bg-white"
    @ok="saveChanges"
  >
    <div class="d-flex flex-column align-items-center">
      <div
        class="rounded-full profile_image"
        :style="imageToDisplay ? `background-image:url(${imageToDisplay})` : ''"
      />
      <div class="d-flex flex-column mt-2 text-sm align-items-center">

        <a
          class="text-primary d-flex align-items-center"
          @click="$refs.pictureInput.click()"
        >
          <span class="action-text">
            {{ uploadText }}
          </span>
          <GjIcon
            :key="uploadIcon"
            :name="uploadIcon"
            size="17"
          />
          <input
            ref="pictureInput"
            style="display: none"
            type="file"
            accept="image/*"
            enctype="multipart/form-data"
            @change="imageSelected"
          >

        </a>
        <a
          v-if="(imageToDisplay) && !removed"
          class="text-danger mt-1 d-flex align-items-center"
          @click="removeImage"
        >
          <span class="action-text">
            Remove
          </span>
          <GjIcon
            name="Close"
            size="17"
          />
        </a>
        <a
          v-if="removed"
          class="d-flex align-items-center mt-1"
        >
          <span class="action-text">
            No Image
          </span>
        </a>
      </div>
    </div>
    <template #modal-ok>
      <div class="d-flex align-items-center">
        <span>
          Save Changes
        </span>
        <b-spinner
          v-if="savingProfilePicture"
          style="margin-left:5px;"
          small
        />
      </div>
    </template>
  </b-modal>
</template>

<script>

import helpers from '@/mixins/helpers'

export default {
  name: 'ProfilePicture',
  mixins: [helpers],
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true,
    },
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showProfilePictureModal: false,
      removed: false,
      uploadedPicture: null,
      uploadedPictureUrl: null,
    }
  },
  computed: {
    uploadText() { return this.url && !this.removed ? 'Change Picture' : 'Select Picture' },
    uploadIcon() { return this.url && !this.removed ? 'Refresh' : 'Plus' },
    imageToDisplay() {
      if (this.removed) return null
      if (this.uploadedPictureUrl) return this.uploadedPictureUrl
      if (this.url) return this.url
      return null
    },
    changed() {
      return this.removed || this.uploadedPictureUrl
    },
    savingProfilePicture() {
      return this.$store.state.profile.savingProfilePicture
    },
  },
  watch: {
    value(val) {
      this.showProfilePictureModal = val
      this.removed = false
      this.uploadedPicture = null
      this.uploadedPictureUrl = null
    },
    showProfilePictureModal(val) {
      this.$emit('input', val)
    },
  },
  created() {
    this.showProfilePictureModal = this.value
  },
  methods: {
    removeImage() {
      if (this.url) {
        this.removed = true
      }
      this.uploadedPicture = null
      this.uploadedPictureUrl = null
    },
    imageSelected(e) {
      const file = e.target.files[0]
      this.removed = false
      this.uploadedPicture = file
      this.uploadedPictureUrl = URL.createObjectURL(file)
    },
    saveChanges(e) {
      e.preventDefault()
      if (this.removed || this.uploadedPicture) {
        this.$store.dispatch('profile/saveProfilePicture', this.removed ? null : this.uploadedPicture)
          .then(() => {
            this.successToast('Profile picture saved successfully.')
            this.$emit('refresh')
            this.showProfilePictureModal = false
          }).catch(() => {
            this.errorToast('Error saving profile picture.')
            this.showProfilePictureModal = false
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/variables/variables';

 .profile_image{
   background-color: $white-300;
   width:150px;
   height:150px;
   border-radius:100%;
   background-size:cover;
   border:1px solid $gray-100;
 }
  .action-text{
    margin-right:5px;
  }
</style>
